export default __webpack_public_path__ + "static/media/TX_Elemental_Plant_Grimory.d9699379.png";